import { IGetEmailImpressaoParametersUseCase } from "../../../presentation/useCases/read/get_email_impressao_parameters_use_case";
import { EmailImpressaoParameters } from "../../models/email_impressao_parameters";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * GetEmailImpressaoParametersUseCase
 */

export class GetEmailImpressaoParametersUseCase implements IGetEmailImpressaoParametersUseCase {
  constructor(private readonly repository: IProjetosRepository) { }

  async execute(idProjetoImpressao: number): Promise<EmailImpressaoParameters> {
    return await this.repository.getEmailImpressaoParameters(idProjetoImpressao);
  }

}
